<nz-result
  nzStatus="403"
  nzTitle="Não autorizado"
  nzSubTitle="Parece que seu usuário não possui acesso a esta funcionalidade e/ou recurso. Caso precise de acesso solicite ao administrador da sua conta.">
  <div nz-result-extra>
    <button nz-button nzType="primary" routerLink="..">Voltar para início</button>
  </div>
</nz-result>
